import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/Profiles/ProfilesSubNav';

export const ProfilesLayout = () => LayoutWithSubNav({ navId });
